export const emailRegex = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');

export const isValidPassword = new RegExp('^(?=.*[A-Z])(?=.*[!@#$&%*])(?=.*[0-9])(?=.*[a-z]).{6,}$');

export const hasOnlyLettersValidator = new RegExp('^[a-z A-Z áàâãéèêíïóôõöúç ÁÀÂÃÉÈÍÏÓÔÕÖÚÇ]{1,}$');

export const youtubeUrlRegex = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/;

export const vimeoUrlRegex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/;
